export default __webpack_public_path__ + "static/media/fireFN0.25b22073.svg";